import React from 'react';
import Link from 'components/commercetools-ui/atoms/link';
import { useFormat } from 'helpers/hooks/useFormat';

const LoggedOut = () => {
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  return (
    <div className="w-235 p-14">
      <Link link="/login" buttonVariant="primary" className="block w-full py-12 text-center font-bold">
        {formatAccountMessage({ id: 'sign.in', defaultMessage: 'Sign In' })}
      </Link>

      <div className="mt-24 flex pb-10">
        <span className="whitespace-nowrap">
          {formatAccountMessage({ id: 'not.member', defaultMessage: 'Not a member' })}?
        </span>
        <Link link="/register" className="ml-4 whitespace-nowrap font-medium text-primary-black hover:underline">
          {formatAccountMessage({ id: 'join.here', defaultMessage: 'Join here' })}
        </Link>
      </div>
    </div>
  );
};

export default LoggedOut;
